import React, { useState, useEffect, useRef, Suspense, lazy } from 'react';
import '../style/VenderCelular.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import Collapse from 'react-bootstrap/Collapse';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import menuLogo from "../assets/imagens/pentalobe.png";
import { useDispatch, useSelector } from 'react-redux';
import { checkAuth } from '../redux/reducers/userSlice';
import { login } from '../redux/actions/auth';
import { AiOutlineCheckCircle } from 'react-icons/ai'; // Importando ícone de sucesso
import { enviarEmail } from '../redux/actions/emailAvaliacao';
import api from '../redux/actions/configApi';
import InputMask from 'react-input-mask';
import MenuPrincipal from "../components/menuPrincipal";
import WhatsApp from "../components/whatsApp";
import LoadingOverlay from "../components/loading";
const Termos = lazy(() => import('../components/termosModal'));
const Rodape = lazy(() => import('../components/rodape'));
const Seo = lazy(() => import('../components/SEO'));

const VenderCelular = () => {

    const [steps, setSteps] = useState([
        { name: 'Marca' },
        { name: 'Tipo' },
        { name: 'Modelo' },
    ]);
    const dispatch = useDispatch();
    const [mainStep, setMainStep] = useState(1);
    const [subStep, setSubStep] = useState(1);
    const [selectedBrand, setSelectedBrand] = useState(null)
    const [selectedBrandName, setSelectedBrandName] = useState(null)
    const [selectedType, setSelectedType] = useState(null);
    const [selectedTypeName, setSelectedTypeName] = useState(null);
    const [selectedModelName, setSelectedModelName] = useState(null);
    const [selectedModel, setSelectedModel] = useState(null);
    const [brandOptions, setBrandOptions] = useState([]);
    const [evaluations, setEvaluations] = useState([]);
    const [mainStepTotal, setMainStepTotal] = useState(4);
    const [selectedOptionsArray, setSelectedOptionsArray] = useState([]);
    const [proposalValue, setProposalValue] = useState(null); // Estado para armazenar o valor da proposta
    const [loading, setLoading] = useState(true); // Estado de carregamento
    const [imageModel, setImageModel] = useState();
    const [open, setOpen] = useState(false);
    const [TipoUser, setTipoUser] = useState('');
    //controle de passos
    const [showAlert, setShowAlert] = useState(false); // Estado para controlar a exibição do alerta
    const [alertMessage, setAlertMessage] = useState(''); // Mensagem do alerta
    const [completedSteps, setCompletedSteps] = useState([]); // Passos principais completados
    const [completedSubSteps, setCompletedSubSteps] = useState({}); // Subpassos completados por etapa
    //Itens formulario
    const [imei, setImei] = useState('');
    const [serialNumber, setSerialNumber] = useState('');
    const [errors, setErrors] = useState({ imei: '', serialNumber: '', confirmPassword: '', cep: '', cpf: '' });
    const [cpf, setCpf] = useState('');
    const [cep, setCep] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [telefone, setTelefone] = useState('');
    const [estado, setEstado] = useState('');
    const [fullName, setFullName] = useState('');
    const [rg, setRg] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [number, setNumber] = useState('');
    const [complement, setComplement] = useState('');
    const [email, setEmail] = useState('');
    const [emailLogin, setEmailLogin] = useState('');
    const [password, setPassord] = useState('');
    const [passwordLogin, setPassordLogin] = useState('');
    const [confirmPassword, setconfirmPassword] = useState('');
    const [confirmEmail, setConfirmEmail] = useState("");
    const [termosConcordados, setTermosConcordados] = useState(false);
    const [loadingCep, setLoadingCep] = useState(false);
    const [enviando, setEnviando] = useState(false);
    const [errors2, setErrors2] = useState({});
    const [showRegistrationForm, setShowRegistrationForm] = useState(false);
    const { user } = useSelector((state) => state.user)
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showTermoModal, setShowTermoModal] = useState(false);
    const [errorMessageLogin, setErrorMessageLogin] = useState([]);
    //  const [errorMessageUnique, setErrorMessageUnique] = useState('');
    const [loadindLogin, setLoadindLogin] = useState(false);
    const [seoUrl, setSeoUrl] = useState(window.location.href);
    //Variaveis selecinadas
    const [conexao, setConexao] = useState(null)
    const [cor, setCor] = useState(null)
    const [operacao, setOperacao] = useState()
    const [capacidade, setCapacidade] = useState(null)
    const [acessorios, setAcessorios] = useState([])
    const [defeitos, setDefeitos] = useState([])
    // Handler to proceed to the next step
    const stepContentRef = useRef(null);
    /****Funções*****/
    const scrollToTop = () => {
        // Aguarda 300ms para garantir que a animação/renderização esteja completa
        setTimeout(() => {
            if (stepContentRef.current) {
                const top = stepContentRef.current.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top,
                    left: 0,
                });
            }
        }, 200);
    };
    const handleNext = () => {
        scrollToTop()
        if (mainStep === 1) {
            if (subStep < mainStepTotal) { // Adjust based on the number of sub-steps
                setSubStep(subStep + 1);
            } else {
                setCompletedSteps(prev => [...prev, mainStep]); //completa o passo 1
                setMainStep(mainStep + 1);
            }
        } else if (mainStep < 5) {
            setMainStep(mainStep + 1);
        }
    };
    //sub
    const handleSubStepClick = (i) => {
        if (i + 1 === 1) {
            setSubStep(i + 1); // Permitir navegação se o sub-step foi concluído
        } else {
            const completedForCurrentMainStep = completedSubSteps[mainStep] || [];
            if (completedForCurrentMainStep.includes(i)) {
                setSubStep(i + 1); // Permitir navegação se o sub-step foi concluído
            } else {
                setAlertMessage(`Conclua o passo ${i} antes de prosseguir para o próximo.`); // Definir a mensagem de alerta
                setShowAlert(true); // Mostrar o alerta
            }
        }
    };
    //principal
    const handleStepClick = (i) => {
        if (i + 1 === 1) {
            setMainStep(i + 1); // Permitir navegação se o sub-step foi concluído
        } else {
            if (completedSteps.includes(i)) {
                setMainStep(i + 1); // Permitir navegação se o sub-step foi concluído
            } else {
                setAlertMessage(`Conclua o passo ${i} antes de prosseguir para o próximo.`); // Definir a mensagem de alerta
                setShowAlert(true); // Mostrar o alerta
            }
        }
    };

    const completeStep2 = (mainStep) => {
        setCompletedSteps(prev => [...prev, mainStep]);
        setMainStep(mainStep + 1); // Permitir navegação se o sub-step foi concluído
        scrollToTop()
    };

    const handleBrandSelection = (brand, subStep2) => {

        setSelectedBrand(brand.id);
        setSelectedBrandName(brand.name);
        setCompletedSubSteps(prev => ({
            ...prev,
            [mainStep]: [...(prev[mainStep] || []), subStep2]
        }));
        handleNext(); // Avançar para o próximo subpasso
    };

    const handleTypeSelection = (type, subStep2) => {
        setSelectedType(type.id);
        setSelectedTypeName(type.name);
        setCompletedSubSteps(prev => ({
            ...prev,
            [mainStep]: [...(prev[mainStep] || []), subStep2]
        }));
        handleNext(); // Avançar para o próximo subpasso
    };

    //Listagens de modelos
    const getCurrentPageItems = () => {
        // Obtém a marca selecionada
        const selectedBrandData = brandOptions.find((brand) => brand.id === selectedBrand);
        // Obtém o tipo selecionado dentro da marca selecionada
        const selectedTypeData = selectedBrandData?.types.find((type) => type.id === selectedType);
        // Verifica se há dados do tipo selecionado; se não houver, retorna um array vazio
        if (!selectedTypeData) return [];
        // Ordena os modelos com base na coluna 'ordem' em ordem crescente
        const orderedModels = [...selectedTypeData.models].sort((a, b) => a.ordem - b.ordem);
        return orderedModels;
    };

    const handleModelSelection = async (model, subStep2) => {

        setSelectedModel(model.id);
        setSelectedModelName(model.name);
        setImageModel(model.image_model);
        // 3. Consulta as avaliações com base no ID do modelo selecionado
        try {
            setLoading(true); // Ativa o carregamento ao iniciar o processo
            const response = await api.get(`evaluations/${model.id}`);
            setCompletedSubSteps(prev => ({
                ...prev,
                [mainStep]: [...(prev[mainStep] || []), subStep2]
            }));
            handleNext(); // Avançar para o próximo subpasso
            const orderedAttributes = response.data.attributes.map((attribute) => {
                // Ordena os valores dentro de cada atributo pela propriedade 'ordem'
                const orderedValores = attribute.valores.sort((a, b) => a.ordem - b.ordem);
                // Retorna o atributo com os valores ordenados
                return {
                    ...attribute,
                    valores: orderedValores,
                };
            }).sort((a, b) => a.ordem - b.ordem);

            setEvaluations(orderedAttributes);
            setSelectedOptionsArray([]);  // Zera as seleções
            const initialSteps = [
                { name: 'Marca' },
                { name: 'Tipo' },
                { name: 'Modelo' },
            ];
            const newSteps = response.data.attributes?.map((item) => {
                return {
                    name: item.attribute_name, // Acessa o nome do atributo corretamente
                    values: item.valores       // Acessa os valores do atributo corretamente
                };
            });
            setSteps([
                ...initialSteps,
                ...newSteps
            ]);
            const total = newSteps.length + initialSteps.length
            setMainStepTotal(total)
            setLoading(false);
            handleNext(); // Avançar para o próximo subpasso
        } catch (error) {
            setLoading(false); // Ativa o carregamento ao iniciar o processo
        }
    };

    const handleOptionSelect = (attributeId, value, id, atributo, subStep2, peso, type) => {

        const newOption = {
            atributo: atributo,
            attributeId: attributeId,
            items: Array.isArray(value) ? value.map((val, index) => ({
                value: val,
                idValue: id[index],
                peso: peso[index],
                type: type[index]
            })) : [{ value, idValue: id, peso, type }]
        };

        setSelectedOptionsArray(prevState => {

            const existingOptionIndex = prevState.findIndex(option => option.attributeId === attributeId);
            if (existingOptionIndex !== -1) {
                // Se o atributo já existe no estado e for 4 ou 6, gerencia os valores e IDs
                if (attributeId === 4 || attributeId === 6) {
                    const currentItems = prevState[existingOptionIndex].items;
                    // Verifica se o valor já está selecionado (remover se já estiver)
                    const itemIndex = currentItems.findIndex(item => item.value === value);
                    if (itemIndex !== -1) {
                        const updatedItems = currentItems.filter(item => item.value !== value);
                        // Remove a entrada se não houver mais valores
                        if (updatedItems.length === 0) {
                            return prevState.filter((_, index) => index !== existingOptionIndex);
                        }
                        // Atualiza o estado removendo o item
                        return prevState.map((option, index) =>
                            index === existingOptionIndex
                                ? { ...option, items: updatedItems }
                                : option
                        );
                    } else {
                        // Se o valor não está selecionado, adiciona-o ao array
                        const updatedItems = [...currentItems, {
                            value: value,
                            idValue: id,
                            peso: peso,
                            type: type
                        }];
                        // Atualiza o estado com os novos itens
                        return prevState.map((option, index) =>
                            index === existingOptionIndex
                                ? { ...option, items: updatedItems }
                                : option
                        );
                    }
                } else {
                    // Para atributos que não são 4 ou 6, substitui o array de itens
                    return prevState.map((option, index) =>
                        index === existingOptionIndex
                            ? { ...option, items: newOption.items }
                            : option
                    );
                }
            } else {
                // Se o atributo ainda não existe no estado, adiciona-o
                return [...prevState, newOption];
            }
        });

        // Só avança o passo se não for 4 ou 6
        if (attributeId !== 4 && attributeId !== 6) {
            setCompletedSubSteps(prev => ({
                ...prev,
                [mainStep]: [...(prev[mainStep] || []), subStep2]
            }));
            handleNext();
        } else {
            setCompletedSubSteps(prev => ({
                ...prev,
                [mainStep]: [...(prev[mainStep] || []), subStep2]
            }));
        }
    }

    //Formulario
    const validateImei = (value) => {
        const imeiDigits = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
        if (imeiDigits.length !== 15) {
            return "IMEI inválido. Deve conter exatamente 15 dígitos.";
        }
        // Algoritmo de Luhn para validar o IMEI
        let sum = 0;

        for (let i = 0; i < 15; i++) {
            let digit = parseInt(imeiDigits[i], 10);

            // Dobra o valor de cada segundo dígito, começando pelo segundo dígito da direita
            if (i % 2 === 1) {
                digit *= 2;
                // Se o resultado for maior que 9, subtrai 9 (ou soma os dois dígitos)
                if (digit > 9) {
                    digit -= 9;
                }
            }
            // Adiciona o valor atual à soma total
            sum += digit;
        }

        // O IMEI é válido se a soma total for múltipla de 10
        if (sum % 10 !== 0) {
            return "IMEI inválido.";
        }

        // Retorna vazio se estiver tudo ok
        return '';
    };

    const validateCpf = (value) => {
        const cpfDigits = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
        if (cpfDigits.length !== 11) {
            return "CPF inválido. Deve conter 11 dígitos.";
        }
        // Verifica se todos os dígitos são iguais (CPFs inválidos como "111.111.111-11")
        if (/^(\d)\1+$/.test(cpfDigits)) {
            return "CPF inválido. Não pode ter todos os dígitos iguais.";
        }

        // Validação dos dígitos verificadores
        let sum = 0;
        let remainder;

        // Valida o primeiro dígito verificador
        for (let i = 1; i <= 9; i++) {
            sum += parseInt(cpfDigits[i - 1]) * (11 - i);
        }

        remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cpfDigits[9])) {
            return "CPF inválido.";
        }

        // Valida o segundo dígito verificador
        sum = 0;
        for (let i = 1; i <= 10; i++) {
            sum += parseInt(cpfDigits[i - 1]) * (12 - i);
        }

        remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cpfDigits[10])) {
            return "CPF inválido.";
        }

        return ''; // CPF válido
    };

    const validateCep = (value) => {
        const cepDigits = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
        if (cepDigits.length !== 8) {
            return "CEP inválido. Deve conter 8 dígitos.";
        }
        return '';
    };

    const handleCpfChange = (e) => {
        const value = e.target.value;
        setCpf(value);
        setErrors({ ...errors, cpf: validateCpf(value) });
    };

    const handleCepChange = (e) => {
        const value = e.target.value;
        setCep(value);

        const cepError = validateCep(value);
        setErrors((prevErrors) => ({ ...prevErrors, cep: cepError }));
        // Se o CEP tiver 8 dígitos válidos, faz a consulta
        if (!cepError && value.replace(/\D/g, '').length === 8) {
            fetchAddressFromCep(value.replace(/\D/g, ''));
        }
    };

    const handleImeiChange = (e) => {
        const value = e.target.value;
        setImei(value);
        setErrors({ ...errors, imei: validateImei(value) });
    };

    const fetchAddressFromCep = async (cepValue) => {
        try {
            setLoadingCep(true); // Inicia o loading
            const response = await fetch(`https://viacep.com.br/ws/${cepValue}/json/`);
            const data = await response.json();
            // console.log(data, 'data')
            if (data.erro) {
                setErrors((prevErrors) => ({ ...prevErrors, cep: 'CEP não encontrado.' }));
            } else {
                setLogradouro(data.logradouro || '');
                setBairro(data.bairro || '');
                setCidade(data.localidade || '');
                setEstado(data.uf || '');
                setErrors((prevErrors) => ({ ...prevErrors, cep: '' })); // Limpa o erro se tiver sucesso
            }
        } catch (error) {
            setErrors((prevErrors) => ({ ...prevErrors, cep: 'Erro ao consultar o CEP.' }));
        } finally {
            setLoadingCep(false); // Finaliza o loading
        }
    };

    //Formulario
    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Captura os dados do formulário
        const formData = {
            imei,
            serialNumber,
            fullName,
            cpf,
            rg,
            birthDate,
            cep,
            address: logradouro,
            number,
            complement,
            neighborhood: bairro,
            city: cidade,
            state: estado,
            email,
            telefone,
            password,
            confirmPassword,
            confirmEmail,
            termosConcordados,
            selectedBrandName,
            selectedModelName,
            selectedTypeName,
            selectedOptionsArray,
            proposalValue,
            TipoUser
        };

        // Valida apenas IMEI e SerialNumber se o usuário estiver logado
        if (user) {
            // alert('com usuário')
            const imeiError = validateImei(imei);
            if (imeiError) {
                setErrors({ imei: imeiError });
                return;
            }
            // Adicione validação do serialNumber se necessário
        } else {
            // Validações completas para usuário não autenticado
            const imeiError = validateImei(imei);
            if (imeiError) {
                setErrors({ imei: imeiError });
                scrollToTop()
                return;
            }
            const cpfError = validateCpf(cpf);
            if (cpfError) {
                setErrors({ cpf: cpfError });
                scrollToTop()
                return;
            }
            const cepError = validateCep(cep);
            if (cepError) {
                setErrors({ cep: cepError });
                scrollToTop()
                return;
            }

            if (formData.email !== formData.confirmEmail) {
                setErrors({ confirmEmail: "Os e-mails digitados não coincidem." });
                return
            }

            if (formData.password !== formData.confirmPassword) {
                setErrors({ confirmPassword: "As senhas não coincidem." });
                return;
            }
        }

        //  Envio da requisição
        try {
            setEnviando(true);
            const response = await api.post(`propostaStore`, formData);
            setCompletedSteps((prev) => [...prev, mainStep]);
            setMainStep(mainStep + 1);
            setEnviando(false);
            scrollToTop();
            setErrors2({});
            dispatch(enviarEmail(response.data.id));
        } catch (error) {
            scrollToTop();
            setEnviando(false);
            console.log(error.response, 'error.response')
            if (error.response) {
                if (error.response.data.errors) {
                    // Processa os erros para pegar apenas a primeira mensagem de cada campo
                    const processedErrors = Object.keys(error.response.data.errors).reduce((acc, field) => {
                        acc[field] = error.response.data.errors[field][0];
                        return acc;
                    }, {});
                    setErrors2(processedErrors);
                }
                if (error.response.data.message) {
                }
            } else {
                console.error('error ao gravar dados do formulário', error);
            }
        }
    };

    const handleCheckboxChange = (event) => {
        setTermosConcordados(event.target.checked);
    };

    const clearForm = () => {
        setImei("");
        setSerialNumber("");
        setFullName("");
        setCep("");
        setLogradouro("");
        setNumber("");
        setCidade("");
        setTelefone("")
        setEstado("");
        setComplement("");
        setBairro("");
        setEmail("");
        setCpf("");
        setBirthDate("");
        setRg("");
        setTipoUser(false)
    }

    const clearFormLogin = () => {
        setImei("");
        setSerialNumber("");
    }

    const handleShowRegistrationForm = () => {
        setShowRegistrationForm(true);
        setTipoUser(false)
        clearForm()
        setErrors2({}); //limpa os erros caso tenha sido ativado
    };

    const handleBackToPrompt = () => {
        setShowRegistrationForm(false);
    };

    const handleShowLoginModal = () => {
        setShowLoginModal(true);
    };

    const handleCloseLoginModal = () => {
        setShowLoginModal(false);
    };

    const handleCloseTermosModal = () => {
        setShowTermoModal(false);
    };

    //Login Submit
    const handleSubmitLogin = async (e) => {
        e.preventDefault();
        // console.log(user, 'user')
        //const credentials = { emailLogin, passwordLogin };
        setLoadindLogin(true)
        const credentials = {
            email: emailLogin,
            password: passwordLogin
        }
        try {
            // Despacha a ação de login e "desembrulha" o payload
            await dispatch(login(credentials)).unwrap();
            await dispatch(checkAuth()).unwrap();
            setShowLoginModal(false)
            clearFormLogin() //limpa o form
            setTipoUser(true) //quando o login foi bem sucedido!
            setLoadindLogin(false)
            setErrors2({}); //limpa os erros caso tenha sido ativado

        } catch (error) {
            console.log(error, 'errorLogin')
            setLoadindLogin(false)
            setErrorMessageLogin(error?.errors);
        }
    };

    function getArticle(attributeName) {
        // Verificação de entrada inválida
        if (typeof attributeName !== 'string' || !attributeName.trim()) {
            return ''; // ou 'o(a)' como fallback neutro
        }

        const name = attributeName.trim().toLowerCase();

        const isPlural = name.endsWith('s');
        const baseName = isPlural ? name.slice(0, -1) : name;

        // Listas de terminações femininas e masculinas
        const femEndings = ['ção', 'são', 'agem', 'dade', 'ice', 'ez', 'iz', 'ão', 'a', 'e'];
        const mascEndings = ['or', 'al', 'el', 'um', 'ente', 'o', 'e'];

        const endsWith = (word, endings) => endings.some(ending => word.endsWith(ending));

        // Heurística para determinar o artigo
        if (isPlural) {
            if (endsWith(baseName, femEndings)) return `as ${attributeName}`;
            if (endsWith(baseName, mascEndings)) return `os ${attributeName}`;
            return `os ${attributeName}`; // fallback para plural
        } else {
            if (endsWith(baseName, femEndings)) return `a ${attributeName}`;
            if (endsWith(baseName, mascEndings)) return `o ${attributeName}`;
            return `e ${attributeName}`; // fallback para singular
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                 setSeoUrl(window.location.href);
                setLoading(true); // Ativa o carregamento ao iniciar o processo
                const response = await api.get('categoryAllAvalicao'); // Seu endpoint aqui
                // console.log(response.data, 'data')
                setBrandOptions(response.data.brands); // Supondo que a resposta tenha os dados de marcas
            } catch (error) {
                console.error('Erro ao carregar as marcas:', error); // Log do erro no console
            } finally {
                setLoading(false); // Desativa o carregamento após concluir, independentemente de erro
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const calculateProposalValue = async () => {
            setProposalValue(null)
            const payload = {
                selectedOptions: selectedOptionsArray,
                idModel: selectedModel  // Inclui o idModel no payload
            };
            try {
                const response = await api.post('calcular-valor-proposta', payload);
                //console.log(response.data.valorBase, 'response');
                setProposalValue(response.data.valorBase); // Atualiza o estado com o valor recebido
            } catch (error) {
                console.error('Erro ao calcular o valor da proposta:', error);
            }
        };

        // Apenas chama a função se mainStep for 2
        if (mainStep === 2) {
            calculateProposalValue();
        }
    }, [mainStep, selectedOptionsArray, selectedModel]); // Dependências: recalcula se mainStep ou selectedOptionsArray mudarem

    useEffect(() => {
        if (user && user.address) {
            setFullName(user.name || "");
            setCep(user.address.cep || "");
            setLogradouro(user.address.address || "");
            setNumber(user.address.number || "");
            setCidade(user.address.city || "");
            setTelefone(user?.telefone || "")
            setEstado(user.address.state || "");
            setComplement(user.address.complement || "");
            setBairro(user.address.neighborhood || "");
            setEmail(user.email || "");
            setCpf(user.cpf || "");
            setBirthDate(user?.data_nascimento || "");
            setRg(user?.rg || "");
            setTipoUser(true)
        }
    }, [user]);


    useEffect(() => {
        let conexaoEncontrada = false;
        let corEncontrada = false;
        let capacidadeEncontrada = false;
        let acessoriosEncontrados = false;
        let defeitosEncontrados = false;
        let operacaoEncontrado = false;
        // Itera sobre o array principal
        selectedOptionsArray.forEach((option) => {
            if (option.atributo === "Conexão" && Array.isArray(option.items)) {
                conexaoEncontrada = true;
                // Atualiza o estado com o valor encontrado
                setConexao(option.items[0]?.value || null); // Primeiro valor ou null
            }
            if (option.atributo === "Capacidade" && Array.isArray(option.items)) {
                capacidadeEncontrada = true;
                setCapacidade(option.items[0]?.value || null);
            }
            if (option.atributo === "Cores" && Array.isArray(option.items)) {
                corEncontrada = true;
                setCor(option.items[0]?.value || null);
            }
            if (option.atributo === "Acessórios" && Array.isArray(option.items)) {
                acessoriosEncontrados = true;
                setAcessorios(option.items);
            }
            if (option.atributo === "Defeitos" && Array.isArray(option.items)) {
                defeitosEncontrados = true;
                setDefeitos(option.items);
            }
            if (option.atributo === "Operação" && Array.isArray(option.items)) {
                operacaoEncontrado = true;
                setOperacao(option.items[0]?.value || null);
            }
        });

        // Redefine o estado se o atributo não foi encontrado
        if (!conexaoEncontrada) setConexao(null);
        if (!capacidadeEncontrada) setCapacidade(null);
        if (!acessoriosEncontrados) setAcessorios([]);
        if (!defeitosEncontrados) setDefeitos([]);
        if (!corEncontrada) setCor(null);
        if (!operacaoEncontrado) setOperacao(null);
    }, [selectedOptionsArray]);


    useEffect(() => {
        if (mainStep === 5) {
            setImei('')
            setSerialNumber('')
        }
    }, [mainStep]); // Executa quando `mainStep` muda

    useEffect(() => {
        if (mainStep === 4) {
            dispatch(checkAuth());
        }
    }, [mainStep, dispatch]);

    return (
        <div>
            <Suspense >
                <Seo
                    title="Venda e Compra de iPhones em Blumenau | Pentalobe"
                    description="Venda seu iPhone de forma rápida e segura em Blumenau! Avaliação justa e pagamento imediato. Clique e saiba mais sobre como vender seu iPhone conosco!"
                    keywords={getCurrentPageItems().length > 0 ? getCurrentPageItems().map(p => p.name).join(', ') : ''}
                    url={seoUrl}
                    type="website"
                />
            </Suspense>
            <Modal show={showAlert} onHide={() => setShowAlert(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Aviso</Modal.Title>
                </Modal.Header>
                <Modal.Body>{alertMessage}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => setShowAlert(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
            <MenuPrincipal />
            <section className='fundo section-spacing'>
                <div className="vender-celular" ref={stepContentRef}>
                    {/* Timeline - Horizontal */}
                    <div className="timeline">
                        {Array.from({ length: 5 }, (_, i) => (
                            <React.Fragment key={i}>
                                {/* Barra de progresso */}
                                {i > 0 && <div className={`timeline-progress ${mainStep > i ? 'active' : ''}`}></div>}
                                {/* Etapa da linha do tempo */}
                                <div
                                    className={`timeline-step ${mainStep === i + 1 ? 'current' : mainStep > i ? 'completed' : ''} ${mainStep === 5 ? 'disabled' : ''}`}
                                    onClick={() => {
                                        if (mainStep < 5) handleStepClick(i);
                                    }}
                                >
                                    <span className="step-number">{i + 1}</span>
                                    <div className="step-label">
                                        {['Configurações', 'Proposta', 'Orientações', 'Formulário', 'Concluído'][i]}
                                    </div>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>

                    {/* Step Content */}
                    <div className="step-content" >
                        {mainStep === 1 && (
                            <div className="configuracoes">
                                <h2><i class="fa-solid fa-gear"></i>  Configurações</h2>
                                {/* Sub-steps - Vertical */}
                                <div className="configuracoes-inter">
                                    <div className="sub-steps">
                                        {steps.map((step, i) => (
                                            <React.Fragment key={i}>
                                                {/* Barra de progresso para sub-passos */}
                                                {i > 0 && <div className={`sub-step-progress ${subStep > i ? 'active' : ''}`}></div>}
                                                <div
                                                    className={`sub-step ${subStep === i + 1 ? 'current' : subStep > i ? 'completed' : ''}`}
                                                    onClick={() => handleSubStepClick(i)}
                                                >
                                                    <span className="sub-step-number">{i + 1}</span>
                                                    <div className="sub-step-label">{step.name}</div>
                                                </div>

                                            </React.Fragment>
                                        ))}
                                    </div>

                                    {/* Content for current sub-step */}
                                    <div className="sub-step-content">
                                        {/* Render dynamic content based on subStep */}
                                        {subStep === 1 &&
                                            <div className={`box-1 loading ${loading ? 'loading-active' : ''}`}>
                                                <h4 className='text-center'>  <span>⬇️</span> Selecione a Marca</h4>
                                                <LoadingOverlay loading={loading} />
                                                <div className='brand-buttons'>
                                                    {Array.isArray(brandOptions) && brandOptions.map((brand) => (

                                                        <button key={brand.id} className='brand-button' onClick={() => handleBrandSelection(brand, subStep)}>
                                                            <img
                                                                src={brand.image_marca}
                                                                alt={`${brand.brand} Logo`}
                                                                className='brand-logo'
                                                            />
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        }
                                        {subStep === 2 &&
                                            <div className='box-1'>
                                                <h4 className='text-center'><span>⬇️</span> Selecione o Tipo</h4>
                                                <div className='brand-buttons'>
                                                    {brandOptions
                                                        .find((brand) => brand.id === selectedBrand)
                                                        ?.types.map((type) => (
                                                            <button
                                                                key={type.id}
                                                                className='brand-button'
                                                                onClick={() => handleTypeSelection(type, subStep)}
                                                            >
                                                                {type.name}
                                                            </button>
                                                        ))}
                                                </div>
                                            </div>}
                                        {subStep === 3 &&
                                            <div className={`box-2 loading ${loading ? 'loading-active' : ''}`}>
                                                <LoadingOverlay loading={loading} />
                                                <h4 className='text-center'><span>⬇️</span> Selecione o Modelo</h4>
                                                <Row>
                                                    {getCurrentPageItems().map((model) => (
                                                        <Col
                                                            key={model.id}
                                                            xs={12} // Em telas pequenas, o botão ocupará 12 colunas (100% da largura)
                                                            md={4} // Em telas maiores que "md", ocupará 6 colunas (50% da largura)
                                                            className="d-flex justify-content-center"
                                                        >
                                                            <button
                                                                className="brand-button"
                                                                onClick={() => handleModelSelection(model, subStep)}
                                                            >
                                                                {model.name}
                                                            </button>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>
                                        }
                                        {evaluations.length > 0 && (() => {
                                            let stepCounter = 4; // Inicializamos o contador de subStep começando em 4
                                            return evaluations?.map((model, index) => {
                                                const modelRender = []; // Acumulador para cada modelo e suas características
                                                const currentSubStep = stepCounter;
                                                console.log(model, 'model')
                                                stepCounter++; // Aumenta o contador para o próximo subStep
                                                // Renderiza o subStep correspondente à característica
                                                modelRender.push(
                                                    <div key={index}>
                                                        {subStep === currentSubStep && (
                                                            <>
                                                                <div className='brand-buttons'>
                                                                    <h4 className='text-center'><span>⬇️</span> Selecione {getArticle(model.attribute_name)}</h4>
                                                                    {model.valores && model.valores.length > 0 && (
                                                                        model.valores.map((value, index) => (
                                                                            <button key={index}
                                                                                className={`brand-button ${selectedOptionsArray.some(option =>
                                                                                    option.attributeId === model.id &&
                                                                                    option.items.some(item => item.value === value.attribute_value)
                                                                                ) ? 'selected' : ''
                                                                                    }`}
                                                                                onClick={() => handleOptionSelect(model.id, value.attribute_value, value.id, model.attribute_name, subStep, value.peso, value.modification_type)}>
                                                                                {value.attribute_value}
                                                                            </button>
                                                                        ))
                                                                    )}
                                                                </div>
                                                                {/* Renderiza o botão "Continuar" apenas quando model.id for 4 ou 6 */}
                                                                {(model.id === 4 || model.id === 6) && (
                                                                    <div className='brand-buttons'>
                                                                        <Button
                                                                            variant="primary"
                                                                            className="continue-button"
                                                                            onClick={handleNext}
                                                                        >
                                                                            Continuar
                                                                        </Button>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                );

                                                // Retorna o JSX acumulado para este modelo
                                                return (
                                                    <div key={model.id}>
                                                        {modelRender}
                                                    </div>
                                                );
                                            });
                                        })()}


                                    </div>
                                </div>
                            </div>
                        )}
                        {/*Apresentação Passo P2*/}
                        {mainStep === 2 && (
                            <div className="summary-container">
                                <h2 className="summary-title"><i class="fa-solid fa-file"></i> Resumo da Configuração</h2>
                                <div className="summary-content-wrapper">
                                    {/* Coluna da listagem de atributos */}
                                    <Row>
                                        <Col md={12} className='d-flex justify-content-center align-items-center mb-3 mt-3 flex-direction-column'>
                                            <img src={imageModel} alt={selectedModelName} className="phone-image" />
                                        </Col>
                                    </Row>
                                    <p className="product-details-name-2">
                                        <span className="model-name">{selectedModelName} {capacidade} {cor} {conexao}</span>
                                    </p>
                                    {acessorios?.length > 0 && (
                                        <div className="accessories-container">
                                            <h5>Acessórios</h5>
                                            <div className="tags-list">
                                                {acessorios?.map((item, index) => (
                                                    <span key={index} className="tag">
                                                        {item?.value}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {defeitos?.length > 0 ? (
                                        <div className="accessories-container">
                                            <h5>Defeitos</h5>
                                            <div className="tags-list">
                                                {defeitos.map((item, index) => (
                                                    <span key={index} className="tag">
                                                        {item?.value}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    ) : null}
                                    <div className="accessories-container">
                                        <h5>Operação</h5>
                                        <div className="tags-list">
                                            <span className="tag">
                                                {operacao}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Container de destaque para o valor da proposta */}
                                <div className="price-container">
                                    <h3 style={{ fontWeight: '500', color: '#333' }}>Valor da Proposta</h3>
                                    <strong className="proposal-value">
                                        {proposalValue !== null ? proposalValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'Calculando...'}
                                    </strong>
                                </div>

                                {/* Botão de ação */}
                                <div className="summary-buttons">
                                    <button disabled={!proposalValue} onClick={() => completeStep2(mainStep)}>Aceitar Proposta</button>
                                </div>
                            </div>
                        )}
                        {/*Orientações Passo P3*/}
                        {mainStep === 3 && (
                            <div className="warnings-section">
                                <h2 className="warnings-title">
                                    <i className="fa-solid fa-circle-exclamation"></i> COMO FUNCIONA?
                                </h2>
                                <ol className="warnings-list">
                                    <li className="warning-item">
                                        <h3><i className="fa-solid fa-user"></i>Cadastro</h3>
                                        <p>Faça seu cadastro informando seus dados e os detalhes do aparelho que deseja vender.
                                        </p>
                                    </li>
                                    <li className="warning-item">
                                        <h3><i className="fa-solid fa-envelope"></i>Acompanhe seu E-mail</h3>
                                        <p>Após concluir o cadastro, você receberá um e-mail com todas as instruções necessárias. Basta segui-las para dar continuidade ao processo de venda.</p>
                                    </li>
                                    <li className="warning-item">
                                        <h3><i className="fa-solid fa-barcode"></i>Envio do Aparelho</h3>
                                        <p>Após seguir as instruções do e-mail, nossa equipe gerará um código de postagem dos Correios em até 24 horas. Com esse código, você poderá enviar seu aparelho sem nenhum custo. Os Correios fornecerão um código de rastreamento para que você possa acompanhar o envio.</p>
                                    </li>
                                    <li className="warning-item">
                                        <h3><i className="fa-solid fa-box"></i> Recebimento e verificação</h3>
                                        <p>Assim que o aparelho chegar até nós, ele será avaliado em até 2 dias úteis (D+2). Se estiver conforme a avaliação feita no site e sem defeitos não informados, o pagamento será realizado automaticamente após a conclusão da análise.</p>
                                    </li>
                                    <li className="warning-item">
                                        <h3><i className="fa-solid fa-exclamation-triangle"></i>Divergências na Avaliação</h3>
                                        <p>Caso identifiquemos algum defeito ou inconsistência não mencionada na proposta, entraremos em contato para informar a situação e apresentar uma nova oferta, caso o aparelho ainda se enquadre nos critérios de compra.</p>
                                    </li>
                                    <li className="warning-item">
                                        <h3><i className="fa-solid fa-undo-alt"></i>Devolução</h3>
                                        <p>Se o aparelho não for aprovado em nossa análise ou caso a nova proposta não seja aceita, ele ficará disponível para devolução.</p>
                                    </li>
                                </ol>
                                <div className="summary-buttons mt-5">
                                    <button onClick={() => handleNext()}>Vamos começar!</button>
                                </div>
                            </div>
                        )}
                        {/*modal Termos*/}
                        <Modal show={showTermoModal} onHide={handleCloseTermosModal} centered size="lg">
                            <Modal.Header closeButton>

                                <Modal.Title className='w-100 text-center titulo-modal'>Termos e Condições</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Suspense>
                                    <Termos />
                                </Suspense>
                            </Modal.Body>
                        </Modal>
                        {/*Orientações Passo P4*/}
                        {mainStep === 4 && (
                            /*formulario*/
                            <>
                                {!user && !showRegistrationForm ?
                                    (<div className="login-prompt-container">
                                        <p className="login-prompt-text">
                                            Para continuar, faça login na sua conta ou crie uma nova!
                                        </p>
                                        <div className="login-prompt-buttons">
                                            <Button onClick={handleShowLoginModal} className="login-button" variant="primary">
                                                <i className="fas fa-sign-in-alt" style={{ marginRight: '8px' }}></i>
                                                Login
                                            </Button>
                                            <Button
                                                onClick={handleShowRegistrationForm}
                                                className="register-button"
                                                variant="secondary"
                                            >
                                                <i className="fas fa-user-plus" style={{ marginRight: '8px' }}></i>
                                                Criar Conta
                                            </Button>
                                        </div>
                                    </div>
                                    ) : (
                                        <div className="form-container">
                                            {(Object.keys(errors2).length > 0) && (
                                                <Alert variant="danger" className='text-center'>
                                                    {Object.keys(errors2).map((key) => (
                                                        <div key={key}>{errors2[key]}</div>
                                                    ))}
                                                </Alert>
                                            )}
                                            {!user && (
                                                <i className="fa-solid fa-circle-arrow-left mb-3"
                                                    onClick={handleBackToPrompt}
                                                    style={{ fontSize: '2em', color: '#F3A52C' }}
                                                >
                                                </i>
                                            )}

                                            <Form onSubmit={handleSubmit}>
                                                <h2 className="form-title">Proposta</h2>
                                                <Row className="mb-3">
                                                    <div className='d-flex align-items-center icone-info'>
                                                        <Form.Group as={Col} md="6">
                                                            <Form.Label className='mt-3'>Valor da Proposta</Form.Label>
                                                            <Form.Control type="text" value={proposalValue?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} readOnly />
                                                        </Form.Group>
                                                        <i
                                                            className="fa-solid fa-circle-info info-icon"
                                                            onClick={() => setOpen(!open)}
                                                            style={{ cursor: 'pointer', fontSize: '1.5rem' }}
                                                        ></i>
                                                    </div>
                                                    <Collapse in={open}>
                                                        <div className="summary-container">
                                                            <Row>
                                                                <Col md={12} className='d-flex justify-content-center align-items-center mb-3 mt-3 flex-direction-column'>
                                                                    <img src={imageModel} alt={selectedModelName} className="phone-image" />
                                                                </Col>
                                                            </Row>
                                                            <p className="product-details-name-2">
                                                                <span className="model-name">{selectedModelName} {capacidade} {cor} {conexao}</span>
                                                            </p>
                                                            {acessorios?.length > 0 && (
                                                                <div className="accessories-container">
                                                                    <h5>Acessórios</h5>
                                                                    <div className="tags-list">
                                                                        {acessorios?.map((item, index) => (
                                                                            <span key={index} className="tag">
                                                                                {item?.value}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {defeitos?.length > 0 ? (
                                                                <div className="accessories-container">
                                                                    <h5>Defeitos</h5>
                                                                    <div className="tags-list">
                                                                        {defeitos.map((item, index) => (
                                                                            <span key={index} className="tag">
                                                                                {item?.value}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                            <div className="accessories-container">
                                                                <h5>Operação</h5>
                                                                <div className="tags-list">
                                                                    <span className="tag">
                                                                        {operacao}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Collapse>
                                                </Row>
                                                <h2 className="form-title">Informações do Aparelho</h2>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} md="6" controlId="imei">
                                                        <Form.Label className='mt-3'>IMEI</Form.Label>
                                                        <InputMask
                                                            mask="99 999999 999999 9"
                                                            value={imei}
                                                            onChange={handleImeiChange}
                                                        >
                                                            {(inputProps) => (
                                                                <Form.Control
                                                                    {...inputProps}
                                                                    type="text"
                                                                    placeholder="Digite o IMEI"
                                                                    isInvalid={!!errors.imei}
                                                                    required
                                                                />
                                                            )}
                                                        </InputMask>
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.imei}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="6" controlId="serialNumber ">
                                                        <Form.Label className='mt-3'>Número de Série</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={serialNumber}
                                                            placeholder="Digite o Número de Série"
                                                            required
                                                            onChange={(e) => setSerialNumber(e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                {/*Informações Pessoais*/}
                                                {!user && ( // Exibe os campos apenas se não houver um usuário autenticado
                                                    <div>
                                                        <h2 className="form-title">Informações Pessoais</h2>
                                                        <Row className="mb-3">
                                                            <Form.Group as={Col} md="6" controlId="fullName">
                                                                <Form.Label className='mt-3'>Nome Completo</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Digite o Nome Completo"
                                                                    value={fullName}
                                                                    required
                                                                    onChange={(e) => setFullName(e.target.value)}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group as={Col} md="6" controlId="cpf">
                                                                <Form.Label className='mt-3'>CPF</Form.Label>
                                                                <InputMask
                                                                    mask="999.999.999-99"
                                                                    value={cpf}
                                                                    onChange={handleCpfChange}
                                                                    required
                                                                >
                                                                    {(inputProps) => (
                                                                        <Form.Control
                                                                            {...inputProps}
                                                                            type="text"
                                                                            placeholder="Digite o CPF"
                                                                            isInvalid={!!errors.cpf}
                                                                            required
                                                                        />
                                                                    )}
                                                                </InputMask>
                                                                <Form.Control.Feedback type="invalid">
                                                                    {errors.cpf}
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group as={Col} md="6" controlId="rg">
                                                                <Form.Label className='mt-3'>RG</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Digite o RG"
                                                                    value={rg}
                                                                    onChange={(e) => setRg(e.target.value)}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group as={Col} md="6" controlId="birthDate">
                                                                <Form.Label className='mt-3'>Data de Nascimento</Form.Label>
                                                                <InputMask
                                                                    mask="99/99/9999" // Formato DD/MM/YYYY
                                                                    value={birthDate}
                                                                    onChange={(e) => setBirthDate(e.target.value)}
                                                                    placeholder="DD/MM/AAAA"
                                                                >
                                                                    {(inputProps) => <Form.Control {...inputProps} type="text" required />}
                                                                </InputMask>
                                                            </Form.Group>

                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group as={Col} md="6" controlId="celular">
                                                                <Form.Label className='mt-3'>Telefone</Form.Label>
                                                                <InputMask
                                                                    mask="(99) 99999-9999" // Máscara para telefone com 9 dígitos no Brasil
                                                                    value={telefone}
                                                                    placeholder="Número do celular"
                                                                    onChange={(e) => setTelefone(e.target.value)}
                                                                >
                                                                    {(inputProps) => <Form.Control {...inputProps} type="text" required />}
                                                                </InputMask>
                                                            </Form.Group>
                                                            <Form.Group as={Col} md="6" controlId="cep">
                                                                <Form.Label className='mt-3'>CEP</Form.Label>
                                                                <InputMask
                                                                    mask="99999-999"
                                                                    value={cep}
                                                                    onChange={handleCepChange}
                                                                >
                                                                    {(inputProps) => (
                                                                        <Form.Control
                                                                            {...inputProps}
                                                                            type="text"
                                                                            placeholder="Digite o CEP"
                                                                            isInvalid={!!errors.cep}
                                                                            required
                                                                        />
                                                                    )}
                                                                </InputMask>
                                                                <Form.Control.Feedback type="invalid">
                                                                    {errors.cep}
                                                                </Form.Control.Feedback>
                                                                {/* Indicador de carregamento enquanto consulta o CEP */}
                                                                {loadingCep && (
                                                                    <Spinner animation="border" role="status" size="sm" className="ms-2">
                                                                        <span className="visually-hidden">Carregando...</span>
                                                                    </Spinner>
                                                                )}
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group as={Col} md="6" controlId="address">
                                                                <Form.Label className='mt-3'>Endereço</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Logradouro"
                                                                    value={logradouro}
                                                                    onChange={(e) => setLogradouro(e.target.value)}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group as={Col} md="6" controlId="number">
                                                                <Form.Label className='mt-3'>Número</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Número"
                                                                    value={number}
                                                                    onChange={(e) => setNumber(e.target.value)}
                                                                    required />
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group as={Col} md="6" controlId="complement">
                                                                <Form.Label className='mt-3'>Complemento</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Complemento"
                                                                    value={complement}
                                                                    onChange={(e) => setComplement(e.target.value)}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group as={Col} md="6" controlId="neighborhood">
                                                                <Form.Label className='mt-3'>Bairro</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Bairro"
                                                                    value={bairro}
                                                                    onChange={(e) => setBairro(e.target.value)}
                                                                />
                                                            </Form.Group>

                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group as={Col} md="6" controlId="city">
                                                                <Form.Label className='mt-3'>Cidade</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Cidade"
                                                                    value={cidade}
                                                                    onChange={(e) => setCidade(e.target.value)}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group as={Col} md="6" controlId="state">
                                                                <Form.Label className='mt-3'>Estado</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Estado"
                                                                    value={estado}
                                                                    onChange={(e) => setEstado(e.target.value)}
                                                                />
                                                            </Form.Group>
                                                            <>

                                                            </>
                                                        </Row>

                                                        <>
                                                            <Row className="mb-3">
                                                                <Form.Group as={Col} md="6" controlId="email">
                                                                    <Form.Label className='mt-3'>E-mail</Form.Label>
                                                                    <Form.Control
                                                                        type="email"
                                                                        placeholder="Digite seu E-mail"
                                                                        required
                                                                        value={email}
                                                                        onChange={(e) => setEmail(e.target.value)}
                                                                    />
                                                                </Form.Group>
                                                                <Form.Group as={Col} md="6" controlId="confirmEmail">
                                                                    <Form.Label className="mt-3">Confirmar E-mail</Form.Label>
                                                                    <Form.Control
                                                                        type="email"
                                                                        placeholder="Confirme seu E-mail"
                                                                        required
                                                                        value={confirmEmail}
                                                                        onChange={(e) => setConfirmEmail(e.target.value)}
                                                                        isInvalid={!!errors.confirmEmail}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {errors.confirmEmail}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Row>
                                                            <Row>
                                                                <Form.Group as={Col} md="6" controlId="password">
                                                                    <Form.Label className='mt-3'>Senha</Form.Label>
                                                                    <Form.Control
                                                                        type="password"
                                                                        placeholder="Digite a Senha"
                                                                        required
                                                                        value={password}
                                                                        onChange={(e) => setPassord(e.target.value)}
                                                                    />
                                                                </Form.Group>
                                                                <Form.Group as={Col} md="6" controlId="confirmPassword">
                                                                    <Form.Label className='mt-3'>Confirmar Senha</Form.Label>
                                                                    <Form.Control
                                                                        type="password"
                                                                        placeholder="Confirme a Senha"
                                                                        required
                                                                        value={confirmPassword}
                                                                        onChange={(e) => setconfirmPassword(e.target.value)}
                                                                        isInvalid={!!errors.confirmPassword}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {errors.confirmPassword}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Row>
                                                        </>
                                                    </div>
                                                )}
                                                {/* Aceitação de Termos */}
                                                <Form.Group className="mb-3">
                                                    <Form.Check
                                                        required
                                                        label={
                                                            <>
                                                                <span
                                                                    style={{ color: "#555", textDecoration: "none", cursor: "pointer" }}
                                                                    onClick={() => setShowTermoModal(true)}
                                                                >
                                                                    Li e Concordo com os <strong>Termos de Uso</strong>
                                                                </span>
                                                            </>
                                                        }
                                                        feedback="Você deve concordar antes de enviar."
                                                        feedbackType="invalid"
                                                        checked={termosConcordados}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                </Form.Group>

                                                {/* Botão de Envio */}
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    <Button type="submit" disabled={enviando}>
                                                        {enviando ? 'Enviando...' : 'Enviar'}
                                                    </Button>
                                                </div>
                                            </Form>
                                        </div>
                                    )}
                                {/*modal login*/}
                                <Modal show={showLoginModal} onHide={handleCloseLoginModal} centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title className='w-100'><img className="logo-menu-login mb-3" src={menuLogo} alt="fundo-imagem-home" /></Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Col lg={12} className='login-form'>
                                            <Form onSubmit={handleSubmitLogin}>
                                                <Form.Group controlId="formEmail">
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        placeholder='Email'
                                                        value={emailLogin}
                                                        onChange={(e) => setEmailLogin(e.target.value)}
                                                    />
                                                </Form.Group>

                                                <Form.Group controlId="formPassword">
                                                    <Form.Label className='pt-3'>Senha</Form.Label>
                                                    <Form.Control
                                                        type="password"
                                                        placeholder='senha'
                                                        value={passwordLogin}
                                                        onChange={(e) => setPassordLogin(e.target.value)}
                                                    />
                                                </Form.Group>
                                                {errorMessageLogin && Object.keys(errorMessageLogin).length > 0 && (
                                                    <Alert variant="danger" className="text-center" style={{ textDecoration: "none" }}>
                                                        <ul className="mb-0">
                                                            {Object.entries(errorMessageLogin).map(([field, messages]) =>
                                                                Array.isArray(messages) ? (
                                                                    messages.map((msg, index) => (
                                                                        <li key={`${field}-${index}`}>{msg}</li>
                                                                    ))
                                                                ) : (
                                                                    <li key={field}>{messages}</li> // Se for uma string única, exibe diretamente
                                                                )
                                                            )}
                                                        </ul>
                                                    </Alert>
                                                )}
                                                <div className='text-center'>
                                                    <Button variant="primary" type="submit" className='mt-3'>
                                                        {loadindLogin ? 'Entrando...' : 'Entrar'}
                                                    </Button>
                                                </div>
                                                <div className='text-center mt-3'>
                                                    <a target='_black' href='/reset-senha' className='mt-3'>
                                                        Esqueceu a senha?
                                                    </a>
                                                </div>
                                            </Form>
                                        </Col>
                                    </Modal.Body>
                                </Modal>
                            </>


                        )}
                        {mainStep === 5 && (
                            <div className="final-step-container">
                                <AiOutlineCheckCircle className="success-icon" />
                                <h2 className="final-step-title">Tudo Pronto! 😄</h2>
                                <p className="final-step-message">
                                    A gente acabou de te enviar um e-mail com todas as  instruções. Fique de olho na sua caixa de entrada!
                                </p>
                                <Button variant="success" size="lg" className="final-step-button">
                                    <a target="_blank" href='/dashboard'>Acessar Painel</a>
                                </Button>
                                <Button variant="primary" size="lg" className="final-step-button m-3">
                                    <a href='/quero-vender'>Nova Proposta</a>
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </section >
            <Suspense>
                <Rodape />
            </Suspense>
            <WhatsApp classe={'whatsapp-componente-flutuante'} />
        </div >
    );
};

export default VenderCelular;